import React from "react";

interface PlanYearIconProps {
  width?: string;
  height?: string;
  fillColor?: string;
}

const PlanYearIcon: React.FC<PlanYearIconProps> = ({
  width = "24px",
  height = "24px",
  fillColor = "#00132E",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 404 374"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M391.45 373.7H12C5.37 373.7 0 368.33 0 361.7C0 355.07 5.37 349.7 12 349.7H391.45C398.08 349.7 403.45 355.07 403.45 361.7C403.45 368.33 398.08 373.7 391.45 373.7Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M295.05 292.28L294.02 292.24C277.27 292 267.66 284.07 260.61 278.26C254.97 273.61 252.04 271.38 247.1 271.38C241.57 271.38 237.85 274.23 231.75 279.27C224.75 285.05 216.05 292.25 202.38 292.25H201.59C187.92 292.25 179.21 285.05 172.22 279.27C166.12 274.23 162.41 271.38 156.87 271.38C151.93 271.38 149 273.61 143.36 278.26C136.31 284.07 126.69 292 109.95 292.24L109.67 292.28H108.92C94.89 292.28 84.73 284.66 76.57 278.53C71.9 275.03 67.08 271.41 64.01 271.41C57.38 271.41 52.01 266.04 52.01 259.41C52.01 252.78 57.38 247.41 64.01 247.41C75.08 247.41 83.53 253.75 90.98 259.34C97.15 263.97 102.51 267.99 108.29 268.27H108.4L109.15 268.26C117.77 268.26 122.1 264.69 128.09 259.75C134.77 254.24 143.09 247.39 156.87 247.39C170.65 247.39 180.67 255.13 187.51 260.78C193.45 265.69 196.78 268.26 201.59 268.26H202.38C207.19 268.26 210.51 265.7 216.46 260.78C223.3 255.13 232.66 247.39 247.1 247.39C261.54 247.39 269.2 254.25 275.88 259.76C281.87 264.7 286.2 268.27 294.82 268.27H295.68C301.46 268.01 306.82 263.99 312.99 259.36C320.44 253.77 328.89 247.43 339.96 247.43C346.59 247.43 351.96 252.8 351.96 259.43C351.96 266.06 346.59 271.43 339.96 271.43C336.89 271.43 332.06 275.05 327.4 278.55C319.24 284.67 309.08 292.3 295.05 292.3V292.28Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M208.32 74.3298H226.91C227.47 74.3298 231.15 77.6298 231.15 77.9198V106.95L173.09 89.0198C172.16 88.2398 172.15 79.5498 172.58 78.0598C172.84 77.1698 176.03 74.3398 176.68 74.3398H195.27L194.97 66.4898C183.81 62.1898 177.61 52.8398 178.96 40.7498C179.79 33.3198 188.56 16.2498 192.55 9.32979C194.68 5.61979 196.67 0.179795 201.53 -0.000205267C206.75 -0.190205 208.86 5.4498 211.04 9.3098C215.23 16.7198 223.82 33.3798 224.62 41.3898C225.8 53.1898 219.46 62.2998 208.62 66.4698L208.32 74.3198V74.3298Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M172.44 130.43L231.08 148.1L231.15 156.52H172.44V130.43Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M231.15 134.34L172.44 116.73V102.38L231.15 120.97V134.34Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M354.12 337.69C347.49 337.69 342.12 332.32 342.12 325.69V185.93C342.12 179.07 336.54 173.49 329.68 173.49H72.94C66.08 173.49 60.5 179.07 60.5 185.93V325.69C60.5 332.32 55.13 337.69 48.5 337.69C41.87 337.69 36.5 332.32 36.5 325.69V185.93C36.5 165.84 52.85 149.49 72.94 149.49H329.68C349.77 149.49 366.12 165.84 366.12 185.93V325.69C366.12 332.32 360.75 337.69 354.12 337.69Z"
      style={{ fill: fillColor }}
    />
  </svg>
);

export default PlanYearIcon;
